"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DatePickerWidgetStyles_1 = require("../../styles/DatePickerWidgetStyles");
var PointerEvents_1 = require("../../utils/PointerEvents");
var DatePickerCell = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerCell, _super);
    function DatePickerCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRef = function (element) {
            _this.element = element;
        };
        return _this;
    }
    DatePickerCell.prototype.componentDidMount = function () {
        this.syncFocus();
    };
    DatePickerCell.prototype.componentDidUpdate = function () {
        this.syncFocus();
    };
    DatePickerCell.prototype.syncFocus = function () {
        if (this.element && this.props.isFocused) {
            this.element.focus();
        }
    };
    DatePickerCell.prototype.getStyle = function (isDisabled, isInCurrMonth, isSelected, isToday) {
        var style;
        if (!isInCurrMonth) {
            style = DatePickerWidgetStyles_1.datePickerCellStyles.inOtherMonths;
        }
        else if (isToday && isSelected) {
            style = DatePickerWidgetStyles_1.datePickerCellStyles.todaySelected;
        }
        else if (isToday) {
            style = DatePickerWidgetStyles_1.datePickerCellStyles.today;
        }
        else if (isSelected) {
            style = DatePickerWidgetStyles_1.datePickerCellStyles.selected;
        }
        else {
            style = DatePickerWidgetStyles_1.datePickerCellStyles.default;
        }
        if (isDisabled) {
            style = tslib_1.__assign(tslib_1.__assign({}, style), DatePickerWidgetStyles_1.datePickerCellStyles.disabled);
        }
        return style;
    };
    DatePickerCell.prototype.render = function () {
        var _a = this.props, isInCurrMonth = _a.isInCurrMonth, isDisabled = _a.isDisabled, isToday = _a.isToday, isSelected = _a.isSelected, isTabbable = _a.isTabbable;
        var style = this.getStyle(isDisabled, isInCurrMonth, isSelected, isToday);
        // cells outside the current month should not be focusable when clicked
        var tabIndex = isInCurrMonth ? isTabbable ? 0 : -1 : undefined;
        var cellProps = {
            'aria-label': this.props['aria-label'],
            'aria-selected': isSelected,
            onFocus: this.props.onFocus,
            role: 'gridcell',
            style: style,
            tabIndex: tabIndex,
        };
        return (React.createElement(PointerEvents_1.PointerEventWrapper, { pointerClick: this.props.onClick },
            React.createElement("div", tslib_1.__assign({}, cellProps, { ref: this.handleRef }), this.props.children)));
    };
    return DatePickerCell;
}(React.PureComponent));
exports.DatePickerCell = DatePickerCell;
//# sourceMappingURL=DatePickerCell.js.map